import { useEffect, useRef, useState } from "react";
import useDarkMode from "../../../hooks/useDarkMode";
import useThemeColor from "../../../hooks/useThemeColor";
import "./PasswordRequirementsInfo.css";

export const PASSWORD_REQUIREMENTS = [
  "At least 6 characters",
  "At least one uppercase letter (A–Z)",
  "At least one digit (0–9)",
  "At least one special character (! @ # $ % ^ & *)",
];

/**
 * Info icon next to a password label; shows the client-side password rules on hover/click.
 */
const PasswordRequirementsInfo = ({ className = "" }) => {
  const isDarkMode = useDarkMode();
  const themeColor = useThemeColor();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <span
      ref={wrapRef}
      className={`password-req-info ${className}`.trim()}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className="password-req-info__btn"
        aria-label="Password requirements"
        aria-expanded={open}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        style={{ color: themeColor || "#0acf97" }}
      >
        <i className="fa fa-info-circle" aria-hidden="true" />
      </button>
      {open && (
        <div
          className={`password-req-info__panel ${
            isDarkMode ? "password-req-info__panel--dark" : ""
          }`}
          role="tooltip"
        >
          <div className="password-req-info__title">Password must include:</div>
          <ul className="password-req-info__list">
            {PASSWORD_REQUIREMENTS.map((rule) => (
              <li key={rule}>{rule}</li>
            ))}
          </ul>
        </div>
      )}
    </span>
  );
};

export default PasswordRequirementsInfo;
